import JSEncrypt from 'jsencrypt';
const CryptoJS = require("crypto-js");

const PUBLIC_KEY = "-----BEGIN PUBLIC KEY-----MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCEOk/WyyJKdAHIfMODFnKg7MBoraFBnL3F18hhLx5n01J5g4hCkmpc5+KQFKIQIA/QWk9m7QBzI/OV9ZDFk54LaWm3xP8C+P1TPp7UVGz3iNDLdvgSxuGEYPmML3NaqkbVlvW7/NlNA3ED4Kao7rR5GUYSdFfbaBoxBFae638hzQIDAQAB-----END PUBLIC KEY-----";
const AES_PUBLIC_KEY = "yoJXYSzZhAOpbEFJklGtqd74X2ChTKOL";

export function aesDecrypt(encrypted: string) {
  let encryptedHexStr = CryptoJS.enc.Hex.parse(encrypted);
  let encryptedBase64Str = CryptoJS.enc.Base64.stringify(encryptedHexStr);
  let key = CryptoJS.enc.Hex.parse(CryptoJS.SHA1(CryptoJS.SHA1(AES_PUBLIC_KEY)).toString().substring(0, 32));
  let decryptedBytes = CryptoJS.AES.decrypt(encryptedBase64Str, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
  return decryptedBytes.toString(CryptoJS.enc.Utf8)
}

export const encryptRsa = (params: any, property: string) => {
  let _publicKey = PUBLIC_KEY;
  if (window.weappTenantEnv?.publicKey) {
    try {
      _publicKey = aesDecrypt(window.weappTenantEnv?.publicKey)
    } catch (e) {
      console.error(e);
    }
  }
  if (params[property]) {
    const encrypt = new JSEncrypt();
    encrypt.setPublicKey(_publicKey);
    const encrypted = encrypt.encrypt(params[property]);
    params[property] = encrypted;
  }
  return params;
}

export const privateKeyDecryption = (privateKey: string, value: string) => {
  const decryptor = new JSEncrypt();
  decryptor.setPrivateKey(privateKey);
  try {
    const decryptedData = decryptor.decrypt(value);
    return decryptedData
  } catch (error: any) {
    console.error('Error decrypting data:', error.message);
  }
}